//pullstate store

import { Store } from 'pullstate';

export const LMSStore = new Store({
    courses: [],
    students: [],
    assignments: [],
});
